import { Box, Grid, Button, MenuItem, InputBase, TextField, Typography, IconButton, Divider } from "@material-ui/core";
import moment from "moment";
import { Autocomplete } from "@material-ui/lab";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search, Close, Add, Replay } from "@material-ui/icons";

import select from "../../../utils/select";

import { getAllProfile } from "../../../reducer/profile/action";
import { filterCouncil } from "../../../reducer/council/action";
import { getAllFaculties } from "../../../reducer/department/action";
import { filterStudentResearchV2 } from "../../../reducer/studentResearch/action";

import StudentProjectModal from "../StudentProjectModal";
import dayjs from "dayjs";
import { API_URLS } from "../../../constants/api";
import { apiCall } from "../../../utils/api";

function StudentProjectButton(props) {
  const dispatch = useDispatch();

  const { year, setYear, chosenDepartmentId, setChosenDepartmentId } = props;

  const role = useSelector((state) => select(state, "userReducer", "role"));
  const council = useSelector((state) => select(state, "councilReducer", "council"));
  const profileDetail = useSelector((state) => select(state, "profileReducer", "detail"));
  const faculties = useSelector((state) => select(state, "departmentReducer", "faculties"));
  const profileDepartments = useSelector((state) => select(state, "profileReducer", "departments"));

  const [open, setOpen] = useState(false);
  const [dueTime, setDueTime] = useState(null);
  const [searchElm, setSearchElm] = useState(null);
  // 0 = "Tất cả tiểu ban" (default). Number > 0 = id của template cụ thể.
  // KHÔNG dùng object — handleReload check isNaN sẽ fail nếu là object.
  const [chosenCouncilId, setChosenCouncilId] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [personalFaculties, setPersonalFaculties] = useState(null);

  const yearRange = [0];
  for (var i = parseInt(moment().format("YYYY")); i >= 2021; i--) yearRange.push(i);

  // Vừa vào lấy hêt profile, lấy hết khoa luôn
  useEffect(() => {
    dispatch(getAllProfile());
    dispatch(getAllFaculties());
    dispatch(filterCouncil({ schoolYear: year }));
  }, []);

  useEffect(() => {
    handleReload();
  }, [year, props.type, profileDetail?.id, chosenDepartmentId, chosenCouncilId]);

  useEffect(() => {
    if (props.type === "admin" && chosenDepartmentId) {
      dispatch(filterCouncil({ departmentId: chosenDepartmentId, schoolYear: year }));
    }
    dispatch(filterCouncil({ schoolYear: year }));
  }, [props.type, chosenDepartmentId]);

  useEffect(() => {
    let newObj;
    if (isSearching) newObj = { ...newObj, search: isSearching ? searchElm : null };

    if (newObj) props.setFilterObj(newObj);
  }, [searchElm, isSearching]);

  // KHÔNG auto-pick first council — mặc định "Tất cả tiểu ban" (id=0).
  // useEffect cũ set chosenCouncilId = council[0] (object) → bug isNaN ở
  // handleReload → page không load data khi vào. User phải tự chọn tiểu ban
  // dropdown thì useEffect mới re-fire với id number → fetch mới chạy.

  // Lấy khoa mà mình làm trưởng khoa
  useEffect(() => {
    if (profileDepartments) {
      const faculty = profileDepartments.filter((department) => {
        const matchProfile = department.departmentProfile?.find((item) => item.profileId === profileDetail.id);
        // 2026-08-14: "isFaculty" không tồn tại ở backend (field ma — không
        // model nào trả về), khiến điều kiện này luôn false → Trưởng khoa
        // không bao giờ được auto-detect khoa mình. Dùng đúng field thật
        // `type === "khoachuyenmon"` (khớp cách BE xác định Khoa, xem
        // GetAllFaculty ở department_repo.go).
        if (department?.type === "khoachuyenmon" && matchProfile.roleInDepartment.toLowerCase() === "leader") return true;
        return false;
      });
      if (faculty.length > 0) {
        // Sort A-Z theo tên khoa (locale tiếng Việt). Phần khoa của reducer
        // (faculties) đã được sort ở reducer, riêng personalFaculties derive
        // local từ profileDepartments → sort tại đây cho đồng bộ.
        const sorted = faculty.slice().sort((a, b) =>
          (a?.name || "").localeCompare(b?.name || "", "vi", { sensitivity: "base", numeric: true })
        );
        setPersonalFaculties(sorted);
        setChosenDepartmentId(sorted[0].id);
      }
    }
  }, [profileDepartments]);

  const handleReload = () => {
    if (props.type === "personal") {
      if (profileDetail?.id) {
        dispatch(
          filterStudentResearchV2({
            schoolYear: year,
            profileId: profileDetail.id.toString(),
          })
        );
      }
    } else if (props.type === "admin") {
      if (chosenDepartmentId && chosenDepartmentId !== 0) {
        dispatch(
          filterStudentResearchV2({
            schoolYear: year,
            departmentId: chosenDepartmentId.toString(),
          })
        );
      } else {
        dispatch(filterStudentResearchV2({ schoolYear: year }));
      }
    } else if (props.type === "mod") {
      if (chosenDepartmentId && chosenDepartmentId !== 0) {
        dispatch(filterStudentResearchV2({ schoolYear: year, departmentId: chosenDepartmentId.toString() }));
      } else {
        dispatch(filterStudentResearchV2({ schoolYear: year }));
      }
    } else {
      // Conference role: luôn dispatch khi component re-render. chosenCouncilId
      // mặc định 0 ("Tất cả") — BE branch 2 (filter by year) sẽ trả về researches
      // của năm. Khi user chọn 1 tiểu ban cụ thể (id > 0), filter theo template
      // ở branch 1 (yêu cầu year=0 để focus theo tiểu ban thay vì năm).
      dispatch(
        filterStudentResearchV2({
          schoolYear: year,
          departmentId: !!chosenDepartmentId ? chosenDepartmentId.toString() : "-1",
          // Refactor 2026-05: payload field đổi tên studentCouncilId →
          // councilTemplateId. BE filter qua bảng assignments thẳng
          // (xem student_research_repo.go nhánh 1). 0 = "Tất cả tiểu ban".
          councilTemplateId: chosenCouncilId.toString(),
        })
      );
    }

    // Lấy giá trị thời gian
    const api = API_URLS.YEARLY_DUE_DATE.filterYearlyDueDate();
    apiCall({ ...api, payload: { type: "student", schoolYear: props.year } }).then(({ response, error }) => {
      if (!error && response.status === 200 && response.data.success) {
        setDueTime(response.data.data[0]);
      }
    });

    // Refactor 2026-05-21: bump reloadKey để Table refetch YearlyDueDate.
    // Trước đó Replay không trigger refresh deadline cell (chỉ list refetch).
    if (typeof props.bumpReload === "function") props.bumpReload();
  };

  const handleInsert = () => setOpen({ insert: true });

  const IS_OPEN_REGISTER = dayjs(dueTime?.regStartTime) <= dayjs() && dayjs() <= dayjs(dueTime?.regEndTime);

  return (
    <>
      <Grid item xs={12}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setIsSearching(true);
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={6}>
              <Typography variant="h5" style={{ lineHeight: "40px" }}>
                <b>Đề tài Nghiên cứu khoa học cấp Sinh viên</b>
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ display: "flex" }}>
              <Box display="flex" flexGrow={1}>
                <Box
                  display="flex"
                  alignItems="center"
                  border="solid 1px #bcbcbc"
                  borderRadius={4}
                  marginRight={0.5}
                  width="100%"
                >
                  <InputBase
                    placeholder="Tìm kiếm"
                    value={searchElm || ""}
                    style={{ padding: "0 12px", flexGrow: 1 }}
                    onChange={(e) => {
                      setIsSearching(false);
                      setSearchElm(e.target.value);
                    }}
                    endAdornment={
                      searchElm && (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setIsSearching(true);
                            setSearchElm(null);
                          }}
                        >
                          <Close size="small" />
                        </IconButton>
                      )
                    }
                  />
                  <Divider orientation="vertical" style={{ width: 1, height: 38 }} />
                  <Box padding="0 16px">
                    <IconButton size="small" type="submit">
                      <Search size="small" />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
              <TextField
                select
                margin="dense"
                size="small"
                variant="outlined"
                SelectProps={{
                  MenuProps: {
                    getContentAnchorEl: null,
                    anchorOrigin: { vertical: "bottom", horizontal: "center" },
                    transformOrigin: { vertical: "top", horizontal: "center" },
                  },
                }}
                label="Năm học"
                value={year}
                onChange={(event) => setYear(event.target.value)}
                style={{
                  width: 136,
                  minWidth: 136,
                  maxWidth: 136,
                  margin: "0 4px",
                }}
              >
                {yearRange.map((year) => (
                  <MenuItem key={`year-${year}`} value={year}>
                    {year === 0 ? "Tất cả" : `${year} - ${year + 1}`}
                  </MenuItem>
                ))}
              </TextField>
              {props.type === "admin" || props.type === "conference" ? (
                <>
                  {((props.type === "admin" && faculties) || role === "sudo-admin") && (
                    <Autocomplete
                      options={[{ id: 0, name: "Tất cả" }, ...(personalFaculties || faculties || [])]}
                      // disabled={role !== "sudo-admin"}
                      getOptionLabel={(option) => option.name}
                      onChange={(_, val) => setChosenDepartmentId(val?.id || 0)}
                      value={[{ id: 0, name: "Tất cả" }, ...(personalFaculties || faculties || [])]?.find(
                        (e) => e.id === chosenDepartmentId
                      )}
                      getOptionSelected={(option, value) => option.id === value?.id}
                      renderInput={(params) => (
                        <TextField {...params} size="small" label="Khoa" variant="outlined" placeholder="Cả trường" />
                      )}
                      style={{ width: 260 }}
                    />
                  )}
                  {props.type === "conference" && (
                    <Autocomplete
                      // Thêm option "Tất cả tiểu ban" (id=0) lên đầu để user
                      // có lựa chọn xem tất cả (mặc định khi vào page).
                      options={[{ id: 0, name: "Tất cả tiểu ban" }, ...(council || [])]}
                      disabled={role !== "sudo-admin"}
                      getOptionLabel={(option) => option.name}
                      onChange={(_, val) => setChosenCouncilId(val?.id || 0)}
                      value={
                        [{ id: 0, name: "Tất cả tiểu ban" }, ...(council || [])].find(
                          (e) => e.id === chosenCouncilId
                        ) || { id: 0, name: "Tất cả tiểu ban" }
                      }
                      getOptionSelected={(option, value) => option.id === value?.id}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label="Tiểu ban"
                          variant="outlined"
                          placeholder="Tất cả tiểu ban"
                        />
                      )}
                      style={{ width: 260 }}
                    />
                  )}
                </>
              ) : (
                <>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={!IS_OPEN_REGISTER}
                    style={{ marginLeft: 4, padding: "5px 0", minWidth: 54 }}
                    onClick={handleInsert}
                  >
                    <Add />
                  </Button>
                </>
              )}
              <Button
                variant="outlined"
                style={{ margin: "0 4px", padding: "5px 0", minWidth: 54 }}
                onClick={handleReload}
              >
                <Replay />
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>

      <StudentProjectModal open={open} year={year} type={props.type} setOpen={setOpen} />
    </>
  );
}

export default StudentProjectButton;

